import { createSelector } from '@ngrx/store';
import { selectDigitaixState } from '../../core.selectors';

export const selectLayoutState = createSelector(
  selectDigitaixState,
  state => state.layout,
);
